import templateUrl from "emun.order/parts/parts-order-list-cards.htm";

export default () => ({ templateUrl });
